<template>
	<div class="report-quiz">
		<div  class="user-actions">
			<a :href="editRoute" v-if="editRoute != null" title="Edit this practice" class="btn btn-edit btn-info" target="_blank">Edit</a>
			<button class="btn btn-report btn-info" title="report this Practice, so our team should look what wrong" @click="reportQuiz(quiz)">Report</button>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'ReportButtons',
		props: {
			editRoute: { default: null },
			quiz: { required: true },
			reportQuiz: { type: Function, default: null }
		},
		data() {
			return {}
		}
	}
</script>

<style lang="scss">
	.report-quiz {
		display: inline-block;
	}
</style>